"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _member = require("@/api/member");
var _MemberDialog = _interopRequireDefault(require("./components/MemberDialog.vue"));
var Member = /*#__PURE__*/function (_Vue) {
  function Member() {
    var _this;
    (0, _classCallCheck2.default)(this, Member);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Member, [].concat(args));
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listQuery", {
      page: 1,
      limit: 10,
      search: ""
    });
    (0, _defineProperty2.default)(_this, "tableData", []);
    (0, _defineProperty2.default)(_this, "dataExport", []);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(Member, _Vue);
  return (0, _createClass2.default)(Member, [{
    key: "created",
    value: function created() {
      this.getTableData();
    }
  }, {
    key: "getTableData",
    value: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _member.memberApi.findAll(this.listQuery);
            case 2:
              res = _context.sent;
              this.tableData = res.data.members;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.memberDialog.handleUpdate(row);
    }
  }]);
}(_vuePropertyDecorator.Vue);
Member = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    MemberDialog: _MemberDialog.default
  }
})], Member);
var _default = exports.default = Member;